export default __webpack_public_path__ + "static/media/sellers-not-selected.c634fbe7.svg";